/**
 * IncomeOrder Entity
 * Constantes del dominio de Órdenes de Ingreso
 */

export * from './constants';
